import {
  fromInt2ii0rejb1w62w as fromInt,
  modulooi4g1kq3dmtt as modulo,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/longAsBigInt/longAsBigInt.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function monthLength(_this__u8e3s4, isLeapYear) {
  switch (_this__u8e3s4) {
    case 2:
      return isLeapYear ? 29 : 28;
    case 4:
    case 6:
    case 9:
    case 11:
      return 30;
    default:
      return 31;
  }
}
function isLeapYear(year) {
  var prolepticYear = fromInt(year);
  var tmp;
  if ((prolepticYear & 3n) === 0n) {
    var tmp_0;
    // Inline function 'kotlin.Long.rem' call
    if (!(modulo(prolepticYear, fromInt(100)) === 0n)) {
      tmp_0 = true;
    } else {
      // Inline function 'kotlin.Long.rem' call
      tmp_0 = modulo(prolepticYear, fromInt(400)) === 0n;
    }
    tmp = tmp_0;
  } else {
    tmp = false;
  }
  return tmp;
}
//region block: exports
export {
  isLeapYear as isLeapYear2i238jn7muq0f,
  monthLength as monthLength2df23yfyn71oo,
};
//endregion

//# sourceMappingURL=dateCalculations.mjs.map
